import { Link } from 'react-router-dom';

const FRIEND_LINKS = [
  { label: '影视资讯速递', to: '/special' },
  { label: '最新上映片单', to: '/category' },
  { label: '高分专题精选', to: '/special' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-50 border-t border-primary-500/25">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
                <span className="font-heading text-foreground-950 text-lg font-bold">禁</span>
              </span>
              <span className="font-heading text-foreground-950 text-lg font-bold">十八禁影视大全</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              我们聚焦最新、最丰富的十八禁（成人向）电影与电视剧，用清晰的信息分区与专业推荐，帮助成年观众快速找到想看的作品。站内不提供在线播放，仅作影视信息与观看引导。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-alert-line text-accent-400" />
              本站内容面向成年用户，未满十八周岁请勿浏览。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-foreground-900 text-sm mb-4">站点导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  影视分类
                </Link>
              </li>
              <li>
                <Link to="/special" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  精选专题
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-900 text-sm mb-4">友情链接</h4>
            <ul className="space-y-2.5 text-sm">
              {FRIEND_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-foreground-600 hover:text-primary-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 十八禁影视大全 · 本站内容均为演示数据，仅供产品效果展示
          </p>
          <p className="text-xs text-foreground-500">信息展示平台 · 不提供在线播放 · 请遵守当地法律法规</p>
        </div>
      </div>
    </footer>
  );
}